import React from 'react';
import axios from 'axios';
import {useNavigate}  from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import NavBar from '../Components/NavBar';
import { SyncLoader } from 'react-spinners';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaArrowLeft } from 'react-icons/fa';
import './ContactUs.css';
import Breadcrumb from '../Components/Breadcrumb';

const ContactUs = () => {
  const navigate = useNavigate();

  const initialValues = {
    name: '',
    email: '',
    phoneNumber: '',
    message: ''
  };

  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email address').required('Email is required'),
    phoneNumber: Yup.string().required('Phone Number is required'),
    message: Yup.string().required('Message is required')
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      await axios.post('https://mo-tours-backend.onrender.com/contact-us', values);
      toast.success('Thank you for reaching out! We will contact you shortly.');
      resetForm();
    } catch (err) {
      toast.error('Submission Failed! Please try again later.');
      // console.error(err.response ? err.response.data : err.message);
    }
    setSubmitting(false);
  };

  const paths = [
    { name: 'Home', link: '/' },
    { name: 'Contact us', link: '/contact-us' }
  ];

  return (
    <>
      <NavBar showFullNav={false} />
      <Breadcrumb paths={paths} isFormPage={true} />
      <div className="contact-Us-container">
        <button className="back-button" onClick={() => navigate(-1)}><FaArrowLeft /></button>
        <h2>Contact Us</h2>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="contactUs-form">
              <div className="form-group">
                <label>Name</label>
                <Field type="text" name="name" />
                <ErrorMessage name="name" component="div" className="error" />
              </div>
              <div className="form-group">
                <label>Email</label>
                <Field type="email" name="email" />
                <ErrorMessage name="email" component="div" className="error" />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <Field type="text" name="phoneNumber" />
                <ErrorMessage name="phoneNumber" component="div" className="error" />
              </div>
              <div className="form-group">
                <label>Message</label>
                <Field as="textarea" name="message" />
                <ErrorMessage name="message" component="div" className="error" />
              </div>
              <button type="submit" disabled={isSubmitting} className="contact-submit-btn">{isSubmitting ? <SyncLoader size={8} color="#ffffff" /> : 'Submit'}</button>
            </Form>
          )}
        </Formik>
        <ToastContainer />
      </div>
    </>
  );
};

export default ContactUs;
